import { SupplierGetResponseType } from "@sellar-io/api-v2/types";
import { ReactElement } from "react";
import { useReadLocalStorage } from "usehooks-ts";
import { SpinnerLegacy } from "../../../../components";
import { useSellarUser } from "../../../../hooks";
import { useUser } from "../../../../hooks/api/v2/user/useUser";
import { useSellarCurrentBusiness } from "../../../../hooks/useSellarCurrentBusiness.shared";
import { UserSignupConfirmationStepContent } from "./UserSignupConfirmationStepContent";

export function UserSignupConfirmationStep({
  supplier,
}: {
  supplier?: SupplierGetResponseType;
}): ReactElement {
  const { user } = useSellarUser();
  const { business, loading } = useSellarCurrentBusiness();
  const userQuery = useUser(user?.id ? parseInt(user.id.toString()) : 0, {
    enabled: !!user?.id,
  });
  const storedBusinessId = useReadLocalStorage<number | undefined>(
    "businessId",
  );

  const hasStoredBusinessId = Boolean(
    storedBusinessId && business && storedBusinessId === business.id,
  );

  // Due to the way the current business loads, we need this in place for
  // when a user is logging in & selecting their business they want to view the storefront as
  // When we land on this page, the previous business is first selected so we have to wait for the
  // useSellarCurrentBusiness to catch up
  // Better loading states needed within useSellarCurrentBusiness
  // Waiting for this to be true, enables us to have a simpler enable option on the connection query
  // in UserSignupConfirmationStepContent
  return (
    <>
      {userQuery.isLoading || !business || loading || !hasStoredBusinessId ? (
        <SpinnerLegacy />
      ) : (
        <UserSignupConfirmationStepContent supplier={supplier} />
      )}
    </>
  );
}
